// extracted by mini-css-extract-plugin
export default {"recos":"J8-z","productCardOverride":"K8-z","rowHasBadge":"L8-z"};